import {useIntl} from 'react-intl';
import {ArrowLeftRight} from 'lucide-react';
import {legNameOf} from '../model/legName';
import {useElapsed} from '../hooks/useElapsed';
import type {CallLeg} from '../model/types';
import {callSurfaceMessages as m} from '../messages';
import {CallAvatar} from './CallAvatar';

export interface HeldCall {
    readonly leg: CallLeg;
    readonly onSwap: () => void;
}

export const HeldCallRow = ({leg, onSwap, floating = false}: HeldCall & {floating?: boolean}) => {
    const intl = useIntl();
    const timer = useElapsed(leg.connectedAt);
    const name = legNameOf(leg, intl);
    return (
        <div
            className={`flex items-center gap-2.5 rounded-xl bg-[var(--phq-call-surface)] px-2.5 py-2 ${floating ? 'w-[320px] phq-call-shadow-menu' : ''}`}
            data-testid="held-call"
        >
            <CallAvatar identity={leg.identity} size={32}/>
            <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold">{name}</p>
                <p className="text-[13px] tabular-nums text-[var(--phq-call-ink-muted)]">
                    {timer ? intl.formatMessage(m.onHold, {timer}) : intl.formatMessage(m.onHoldNoTimer)}
                </p>
            </div>
            <button
                type="button"
                data-testid="held-call-swap"
                aria-label={intl.formatMessage(m.swapAria, {name})}
                onClick={onSwap}
                className="phq-call-press inline-flex h-8 shrink-0 items-center gap-1.5 rounded-[10px] bg-[var(--phq-call-surface-muted)] px-2.5 text-[13px] font-semibold"
            >
                <ArrowLeftRight size={14} aria-hidden="true"/>
                {intl.formatMessage(m.swap)}
            </button>
        </div>
    );
};
